import { Route, Routes } from "react-router-dom";
import MainLayout from "./components/layout/main-layout";
import { SobreNosTabProvider } from "./contexts/SobreNosTabContext";
import { AppRoute } from "./interfaces/AppRoute";
import { getRoutes } from "./modules/routes";

function App() {

  let routes: AppRoute[] = [...getRoutes()];

  return (
    <SobreNosTabProvider>
      <Routes>
        {routes.map((route: AppRoute) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <MainLayout>{route.component}</MainLayout>
            }
          />
        ))}
      </Routes>
    </SobreNosTabProvider>
  );
}

export default App;
